import cachedFetch from './cachedFetch';
import { rumSetUser } from '@scale/frontend-lib/datadog';
import { useQuery } from '@tanstack/react-query-v4';
import { ICorpUserJson } from '@scale/shared/types/user';

const GET_USER_URL = 'internal/logged_in_user';

async function cachedGetUser() {
  const user = await cachedFetch<ICorpUserJson>(GET_USER_URL);
  rumSetUser(user);
  return user;
}

export function useUser() {
  const {
    isLoading,
    isError,
    data: user,
  } = useQuery<ICorpUserJson>({
    queryKey: ['user'],
    queryFn: cachedGetUser,
    retry: false,
  });

  return {
    isLoading,
    isError,
    user,
  };
}
